import { Suspense } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "./Header.css";
import SearchButton from "./SearchButton";
import { useAuth0 } from "@auth0/auth0-react"; 
import AuthenticatedContent from './AuthenticatedContent.tsx';

const Header = () => {

  const { isAuthenticated, loginWithRedirect } = useAuth0(); // Хуки для авторизации
  const location = useLocation(); // Получаем текущий путь
  const currentPath = location.pathname; // Текущий URL

  return (
    <div id="header" aria-label="Главная страница">
      
      <div className="header_top">
        
      <SearchButton />
      
      <Link to="/18+" className="img18" title="18+">🔞</Link>

      <Link to="/auslandsamt" 
          className={`auslandsamt ${currentPath.startsWith('/auslandsamt') ? 'active' : ''}`} 
          title="Auslandsamt">🌐</Link>

      <Link to="/wos"
          className={`wos ${currentPath.startsWith('/wos') ? 'active' : ''}`} 
          title="ВОС">⚖️</Link>


        {/* Обновлённая кнопка "Личный кабинет" */}
          {isAuthenticated ? (
          <Link
            to="/lk"
            className="demo_but"
            aria-label="Перейти в Личный кабинет"
            title="Перейти в Личный кабинет"
          />
           ) : (
          <button
            className="demo_but"
            onClick={() => loginWithRedirect()}
            aria-label="Войти в Личный кабинет"
            title="Войти в Личный кабинет"
            role="button"
          />
        )}

      </div>

      <div className="header_bot">
          <a className="none" href="https://sergey-mavrodi.com">
            <h1>Официальный сайт Сергея Мавроди</h1>
          </a>
      </div>
      
      <div className="main_menu">
        <Link
          to="/kinotheater"
          className={`main_menu_link eins ${currentPath.startsWith('/kinotheater') ? 'active' : ''}`}
          aria-label="Перейти в раздел KinoTheater"
        >
          KinoTheater
        </Link>
        <Link
          to="/news"
          className={`main_menu_link zwei ${currentPath.startsWith('/news') ? 'active' : ''}`}
          aria-label="Перейти в раздел Новости"
        >
          НОВОСТИ
        </Link>
        <Link
          to="/schriftstellerei"
          className={`main_menu_link drei ${currentPath.startsWith('/schriftstellerei') ? 'active' : ''}`}
          aria-label="Перейти в раздел Творчество"
        >
          ТВОРЧЕСТВО
        </Link>
      </div>
          

      <div className="banner-wrap">
      <Link
        to="/privacy"
        className="banner"
        aria-label="Перейти на страницу Феникс"
      >
        <span className="banner-text">
          <span className="banner-text-inner">ФЕНИКС</span>
        </span>
      </Link>
      </div>

      <Link to="/ideology" className="ideology" title="Идеология" aria-label="Идеология"></Link>

      {/* <div className="banner">
        <a href="/https://sergeymavrodi.com"></a>
      </div> */}

{isAuthenticated && (
        <Suspense fallback={<div>...</div>}>
          <AuthenticatedContent />
        </Suspense>
      )}

    </div>
    
  );
};

export default Header;
